// extracted by mini-css-extract-plugin
export default {"header":"Header_header__xlxGq","header_nav":"Header_header_nav__xVMxC","header_nav__link":"Header_header_nav__link__WyW4Z","header_logo":"Header_header_logo__nfB82"};